import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  editCompanyRoot: {
    marginTop: "8px",
    marginBottom: "60px",
    [theme.breakpoints.down("md")]: {
      marginBotton: "48px",
    },
  },
  editCompanyContainer: {
    display: "flex",
    width: "285px",
    alignItems: "center",
    justifyContent: "space-between",

    [theme.breakpoints.down("md")]: {
      marginTop: 10,
      width: "100%",
    },
  },
  imageUploadContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "1rem",
  },
  imageForm: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  companyImage: {
    height: "97px",
    width: "97px",
  },
  imageDetails: {
    flex: 1,
    marginLeft: "2rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    maxWidth: "130px",
  },
}));
